<template>
    <div class="project-basics" ref="stepRoot">
        <div class="row m-0 align-items-end g-2">
            <!--client_name  -->
            <div class="col-md-12 ps-0">
                <form-el-select
                    name="client_id"
                    :options="clientsForSelect"
                    :label="$t('fields.client_name')"
                    :model="project"
                    :errors="formErrors"
                    label-field="fields.client_name"
                    :required="true"
                    clearable
                    :action-option-enabled="true"
                    :action-option-label="$t('messages.add_client')"
                    @action="openClientModal"
                    :show-option-avatar="true"
                    option-avatar-field="avatar_url"
                    :avatar-size="20"
                    :placeholder="$t('placeholders.client_name_placeholder')"
                    popper-class="client-select-dropdown"
                />
            </div>
            <!-- <div class="col-md-2 d-flex justify-content-start" style="margin-bottom: 20px;" >
                <button 
                    type="button"
                    class="btn btn-primary  "
                    @click="showClientModal = true"
                    :title="$t ? $t('messages.add_client') : 'Add Client'"
                >
                    Add New Client
                </button>
            </div> -->
        </div>
        <div class="row m-0">
            <!--client_website  -->
            <div class="col-md-6 mt-2 ps-0">
                <form-input
                    type="text"
                    id="client_website_url"
                    :label="$t('fields.client_website')"
                    :required="false"
                    :placeholder="client.website_url || $t('placeholders.website_url_placeholder')"
                    disabled
                />
            </div>
            <!--industry  -->
            <div class="col-md-6 mt-2 ps-0">
                <form-el-select
                    id="user_industry"
                    :label="$t('fields.client_industry')"
                    :disabled="true"
                    :model="client"
                    name="industry_id"
                    :options="industriesForSelect"
                    :placeholder="$t('placeholders.industr_placeholder')"
                />
            </div>
           
            <!--user_camp  -->
            <div class="col-md-6 mt-2 ps-0">
                <form-input
                    type="text"
                    id="user_camp"
                    :label="$t('fields.client_camp')"
                    :required="false"
                    disabled
                    :placeholder="client.camp || $t('placeholders.camp_placeholder')"
                />
            </div>
            <!--user_abbreviation  -->
            <div class="col-md-6 mt-2 ps-0">
                <form-input
                    type="text"
                    id="user_abbreviation"
                    :label="$t('fields.client_abbreviation')"
                    :required="false"
                    :placeholder="client.abbreviation || $t('placeholders.abbreviation_placeholder')"
                    disabled
                />
            </div>

             <!--client_type  -->
             <div class="col-md-6 mt-2 ps-0">
                <form-el-select
                    id="user_client_type"
                    :label="$t('fields.client_type')"
                    :disabled="true"
                    :model="client"
                    name="client_type_id"
                    :options="clientTypesForSelect"
                    :placeholder="$t('placeholders.client_type_placeholder')"
                    :clearable="false"
                />
            </div>

        </div>
        <create-client-modal
        v-model="showClientModal"
        @created="onClientCreated"
        :industries-for-select="props.industriesForSelect"
        :client-types-for-select="props.clientTypesForSelect"
         />
    </div>
   
</template>

<script setup>
import { ref, watch, onMounted, nextTick } from "vue";
import CreateClientModal from "@/views/admin/clients/CreateClientModal.vue";

const props = defineProps({
    project: {
        type: Object,
        default: () => ({}),
    },
    v$: {
        type: Object,
        default: () => ({}),
    },
    formErrors: {
        type: Object,
        default: () => ({}),
    },
    clientsForSelect: {
        type: Array,
        default: () => [],
    },
    industriesForSelect: {
        type: Array,
        default: () => [],
    },
    clientTypesForSelect: {
        type: Array,
        default: () => [],
    },
});

const client = ref({
    website_url: "",
    camp: "",
    abbreviation: "",
    industry_id: null,
    client_type_id: null,
});

const showClientModal = ref(false);
const stepRoot = ref(null);
const openClientModal = () => {
    showClientModal.value = true;
};
onMounted(async () => {
    await nextTick();
    const dialogBody = stepRoot.value?.closest(".el-dialog__body");
    if (dialogBody && typeof dialogBody.scrollTo === "function") {
        dialogBody.scrollTo({ top: 0, behavior: "smooth" });
    } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
});

watch(
    () => props.project.client_id,
    (newId) => {
        const found = props.clientsForSelect.find((c) => c.id === newId);
        if (found) {
            client.value.website_url = found.website_url || "";
            client.value.camp = found.camp || "";
            client.value.abbreviation = found.abbreviation || "";
            client.value.industry_id = found.industry_id || null;
            client.value.client_type_id = found.client_type_id || null;
        } else {
            // Clear all fields when no client is selected
            client.value.website_url = "";
            client.value.camp = "";
            client.value.abbreviation = "";
            client.value.industry_id = null;
            client.value.client_type_id = null;
        }
    },
    { immediate: true }
);

// also reload readonly client fields when clients list changes (e.g., after creating)
watch(
    () => props.clientsForSelect,
    () => {
        const found = props.clientsForSelect.find(
            (c) => c.id === props.project.client_id
        );
        if (found) {
            client.value.website_url = found.website_url || "";
            client.value.camp = found.camp || "";
            client.value.abbreviation = found.abbreviation || "";
            client.value.industry_id = found.industry_id || null;
            client.value.client_type_id = found.client_type_id || null;
        }
    },
    { deep: true }
);

function onClientCreated(created) {
    // ensure new client is added to select options if not present
    if (created && created.id) {
        const exists = props.clientsForSelect.find((c) => c.id === created.id);
        if (!exists) {
            props.clientsForSelect.push({
                id: created.id,
                name: created.name,
                label: created.name,
                website_url: created.website_url,
                camp: created.camp,
                abbreviation: created.abbreviation,
                industry_id: created.industry_id,
                client_type_id: created.client_type_id,
            });
        }
        props.project.client_id = created.id;
    }
}
</script>

<style scoped>
.add-client-btn {
    width: 44px;
    height: 44px;
    padding: 0;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    line-height: 1;
}
</style>

<style>
/* Ensure dropdown appears above modal with proper z-index */
.client-select-dropdown {
    z-index: 3000 !important;
}
</style>
